import React from 'react'
import Helmet from 'react-helmet'
import data from '../../data/digital-realities'

import SlideshowFooter from '../../components/SlideshowFooter'

let id = 3;
let video = '#';
let prev = '/digital-realities/vr_250-williams';
let next = '/digital-realities/vr_atlanta-financial-center';

let listItems = data[id].scope.map( item => {
    return(
        <li>{item}</li>
    )
});

const DigitalRealities = (props) => (
    <div id="digital-reality-landing">
        <Helmet>
            <title>IMBIBE - Digital Realities: {data[id].name}</title>
            <meta name="description" content={`IMBIBE - Digital Realities: ${data[id].name}`} />
            <link rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
            <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
        </Helmet>

        <id id="hero">
            <img src={data[id].hero} />
        </id>

        <div id="main">
            <section id="one">
                <div className="inner">
                    <h2>{data[id].name}</h2>
                    <p>{data[id].copy}</p>
                    <span>Scope of Work:</span>
                    <ul>
                        {listItems}
                    </ul>
                    { data[id].video &&
                    <a href={data[id].video} className="button special small">Watch Video</a>
                    }
                </div>
            </section>
        </div>

        <SlideshowFooter vr prev={prev} next={next} />

    </div>
)

export default DigitalRealities


// WEBPACK FOOTER //
// ./src/pages/digital-realities/vr_colony-square.js